import type { TOC } from '@ember/component/template-only';
import { PrismIllustration } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import GeneralPageHeader from 'lumen/components/general/page/header';
import GeneralPageMain from 'lumen/components/general/page/main';

import styles from './error.module.css';

interface GeneralPageErrorSignature {
  Args: {
    errorCode: string;
  };
  Blocks: {
    default: [];
  };
}

const GeneralPageError = <template>
  <GeneralPageHeader />

  <GeneralPageMain>
    <div class="content-wrapper main-content h-full">
      <div class={{styles.error-message-wrapper}} data-test-id="error-wrapper">
        <div class={{styles.main-error-message}} data-test-id="error-message">
          <PrismIllustration
            @name="100x100_critical"
            @size="medium"
            class={{styles.error-icon}}
            data-test-id="error-icon"
          />

          <h1>
            {{t "general.error_title"}}
          </h1>

          <br />
          {{t "general.error"}}
          <br />
          <br />

          {{#unless (eq @errorCode "unknown")}}
            {{t "general.error_code"}}:{{@errorCode}}
          {{/unless}}

          {{yield}}
        </div>
      </div>
    </div>
  </GeneralPageMain>
</template> satisfies TOC<GeneralPageErrorSignature>;

export default GeneralPageError;
